export default {
  ID: 'Kit ID',
  NICKNAME: 'Nickname',
};
